export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["debug"] = 0] = "debug";
    LogLevel[LogLevel["info"] = 1] = "info";
    LogLevel[LogLevel["warning"] = 2] = "warning";
    LogLevel[LogLevel["error"] = 3] = "error";
})(LogLevel || (LogLevel = {}));



//////////////////
// WEBPACK FOOTER
// ./app/shared/services/log-level.ts
// module id = 14
// module chunks = 0 1 2 3 4 5